import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import handleErrorLandings from "../handleErrorLandings";
import OtherInsuranceQuotation from "./OtherInsuranceQuotation";
import { db } from "../../../firebase";
import { differenceInMonths } from "date-fns";

const landingId = "CF_OTHER_INSURANCE_QUOTATION";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <OtherInsuranceQuotation state={state} setState={setState} />
);

const nextPage = async (props) => {
  const prevForm = props.prevForm;
  const landings = prevForm.items;
  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;
  const isMoreThanOne = products.length > 1;
  if (isMoreThanOne) return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
  const { claimRate, yearsInsured, userUtility } = prevForm.metadata;
  const userRef = doc(db, `users/${props.uid}`);
  const userSnap = await getDoc(userRef);

  const { cancelationDiscountAcceptedAt } = userSnap.data();

  if (cancelationDiscountAcceptedAt) {
    const discountDate = new Date(cancelationDiscountAcceptedAt);
    const currentDate = new Date();

    const monthsDifference = differenceInMonths(currentDate, discountDate);

    if (monthsDifference <= 1) {
      return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
    }
  }

  if (!claimRate || !yearsInsured || !userUtility) {
    await handleErrorLandings({
      error: "Claim Rate not found in metadata",
      landingId,
      message: `[Error Ofrecer Descuento][OFFER_DISCOUNT] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${props.uid}`,
    });
    return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
  }
  console.log("metada" , { claimRate, yearsInsured, userUtility });
  
  if (yearsInsured < 0.5 || userUtility > 0.5) {
    return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
  }

  if (claimRate > 0.6) {
    return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
  }

  return `/formulario/cancelacion/descuento?uid=${props.uid}`;
};

const prevPage = (props) =>
  `/formulario/cancelacion/otro-seguro?uid=${props.uid}`;

const fieldsStructure = [];

const otherInsuranceQuotationProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default otherInsuranceQuotationProps;
